import type { ActivityTrendBucket } from '@terra/shared-contracts-applications';
import type { Token } from '@terra/ui-styled-system';

export const ACTIVITY_TREND_SERIES_KEYS = [
  'executions',
  'signals',
  'findings',
] as const;

export type ActivityTrendSeriesKey =
  (typeof ACTIVITY_TREND_SERIES_KEYS)[number];

export const ACTIVITY_TREND_SERIES_COLOR_TOKENS = {
  executions: 'colors.sky.11',
  signals: 'colors.purple.10',
  findings: 'colors.orange.10',
} as const satisfies Record<
  ActivityTrendSeriesKey,
  Extract<Token, `colors.${string}`>
>;

export type ActivityTrendSeries = {
  key: ActivityTrendSeriesKey;
  data: number[];
  total: number;
};

export const buildActivityTrendSeries = (
  buckets: ActivityTrendBucket[],
): ActivityTrendSeries[] =>
  ACTIVITY_TREND_SERIES_KEYS.map((key) => {
    const data = buckets.map((bucket) => bucket[key]);

    return {
      key,
      data,
      total: data.reduce((sum, count) => sum + count, 0),
    };
  });

export const hasActivityTrendData = (series: ActivityTrendSeries[]): boolean =>
  series.some((entry) => entry.total > 0);

export const toActivityTrendBucketDate = (start: string): Date =>
  new Date(`${start}T00:00:00.000Z`);
